export default function getQuantity(searchFilters) {
  let initialQuantity = [];

  // Función para generar quantity a partir de passengers
  const getQuantityFromPassengers = passengers => {
    // Agrupamos pasajeros por sequence (habitaciones)
    const grouped = {};
    passengers.forEach(p => {
      if (!grouped[p.sequence]) grouped[p.sequence] = [];
      grouped[p.sequence].push(p);
    });

    // Generamos quantity
    return Object.keys(grouped).map((seq, index) => {
      const passengersInRoom = grouped[seq];

      const adults = passengersInRoom.filter(p => p.id_passenger_type === 1)
        .length;

      const men = passengersInRoom
        .filter(p => p.id_passenger_type !== 1)
        .map(p => ({
          childNumber: p.id_passenger_type === 2 ? 1 : 0,
          age: p.age,
        }));

      return {
        n: index + 1,
        adt: adults,
        men,
      };
    });
  };

  // Si searchFilters ya trae quantity, usamos eso
  if (searchFilters.quantity && searchFilters.quantity.length > 0) {
    initialQuantity = searchFilters.quantity.map(room => ({
      n: room.n,
      adt: room.adt,
      men:
        room.men?.map(child => ({
          childNumber: child.childNumber,
          age: child.age,
        })) || [],
    }));
  } else if (searchFilters.passengers && searchFilters.passengers.length > 0) {
    // Generamos quantity a partir de passengers
    initialQuantity = getQuantityFromPassengers(searchFilters.passengers);
  } else {
    // Si no hay pasajeros ni quantity, generamos una habitación por defecto
    const totalRooms = searchFilters.roomInfo?.totalRooms || 1;
    const totalPassengers = searchFilters.roomInfo?.total_passengers || 2;

    for (let i = 0; i < totalRooms; i++) {
      initialQuantity.push({
        n: i + 1,
        adt: totalPassengers,
        men: [],
      });
    }
  }
  return initialQuantity;
}
